var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTryAgain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.625,
    y: 4.125,
    width: 6.75,
    height: 7.875,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.975 10.875L7 8.85L9.025 10.875L9.8125 10.0875L7.7875 8.0625L9.8125 6.0375L9.025 5.25L7 7.275L4.975 5.25L4.1875 6.0375L6.2125 8.0625L4.1875 10.0875L4.975 10.875ZM7 13.6875C6.22187 13.6875 5.49062 13.5397 4.80625 13.2442C4.12187 12.9491 3.52656 12.5484 3.02031 12.0422C2.51406 11.5359 2.11337 10.9406 1.81825 10.2562C1.52275 9.57187 1.375 8.84062 1.375 8.0625C1.375 7.28437 1.52275 6.55312 1.81825 5.86875C2.11337 5.18437 2.51406 4.58906 3.02031 4.08281C3.52656 3.57656 4.12187 3.17569 4.80625 2.88019C5.49062 2.58506 6.22187 2.4375 7 2.4375C7.77812 2.4375 8.50937 2.58506 9.19375 2.88019C9.87812 3.17569 10.4734 3.57656 10.9797 4.08281C11.4859 4.58906 11.8866 5.18437 12.1817 5.86875C12.4772 6.55312 12.625 7.28437 12.625 8.0625C12.625 8.84062 12.4772 9.57187 12.1817 10.2562C11.8866 10.9406 11.4859 11.5359 10.9797 12.0422C10.4734 12.5484 9.87812 12.9491 9.19375 13.2442C8.50937 13.5397 7.77812 13.6875 7 13.6875Z",
    fill: "#F04248"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryAgain);
export default __webpack_public_path__ + "static/media/try-again.9b13e93ff170259f16e0caff13aeb152.svg";
export { ForwardRef as ReactComponent };